module.exports = __webpack_public_path__ + "img/history.a0c311fc.svg";